import * as React from 'react';
import { Button, UIHeading2, UIText2, UIText3 } from '@cian/ui-kit';

import { useSelector } from 'react-redux';
import * as styles from './CianMortageBanner.css';
import { SHOWN_BANKS_COUNT } from './constants';
import { selectActualBanksIds } from '../../selectors/actualMortgageData';
import { useApplicationContext } from '../../utils/withApplicationContext';

export interface IBank {
  id: string;
  name: string;
  icon: string;
  logo: string;
  enabled: boolean;
}

export interface ICianMortgageBannerProps {
  monthlyPayment: string;
  onClick?(event: React.MouseEvent): void;
  url: string;
}

export const CianMortgageBanner: React.FC<ICianMortgageBannerProps> = ({ monthlyPayment, onClick, url }) => {
  const { config } = useApplicationContext();

  const actualBanksIds = useSelector(selectActualBanksIds);
  const banks = config.get<{ mortgageBanksList: IBank[] }>('offerCard.banksList')?.mortgageBanksList ?? [];
  const actualBanks = banks?.filter(item => actualBanksIds.has(item.id));

  return (
    <a
      className={styles['banner']}
      href={url}
      onClick={onClick}
      rel="noopener noreferrer"
      target="_blank"
      data-testid="CianMortgageBanner"
    >
      <div className={styles['logo-and-banks']}>
        <div className={styles['logo']} />
        <div className={styles['banks']}>
          {actualBanks.slice(0, SHOWN_BANKS_COUNT).map(bank => (
            <div key={bank.id} className={styles['circle']}>
              <img className={styles['bank-logo']} alt="" src={bank.logo} width={30} height={30} />
            </div>
          ))}
          {actualBanks.length > SHOWN_BANKS_COUNT && (
            <div className={styles['circle']}>
              <UIText3>+{actualBanks.length - SHOWN_BANKS_COUNT}</UIText3>
            </div>
          )}
        </div>
      </div>
      <div className={styles['payment']}>
        <UIText2>Ежемесячный платеж</UIText2>
        <UIHeading2 data-mark="BannerMonthlyPayment">{monthlyPayment}</UIHeading2>
      </div>
      <div className={styles['button']}>
        <Button type="button" fullWidth>
          Подать заявку онлайн
        </Button>
      </div>
    </a>
  );
};
